import { Category as CategoryRoot } from './Category';
import { CategoryGroup } from './Group/CategoryGroup';
import { CategoryGroupTitle } from './GroupTitle/CategoryGroupTitle';
import { CategoryItem } from './Item/CategoryItem';

export const Category = Object.assign(CategoryRoot, {
  Group: CategoryGroup,
  GroupTitle: CategoryGroupTitle,
  Item: CategoryItem,
});
